import { apiService } from '../services/apiService';

const BASE_URL = '/api/transactions';

export const createTransaction = async (transactionData) => {
  try {
    const response = await apiService.post(BASE_URL, transactionData);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message || 'Failed to create transaction');
  }
};

export const listTransactions = async (params = {}) => {
  try {
    const queryParams = new URLSearchParams();
    
    // Add pagination params
    if (params.page) queryParams.append('page', params.page);
    if (params.limit) queryParams.append('limit', params.limit);
    
    // Add search and filter params
    if (params.search) queryParams.append('search', params.search);
    if (params.payment_source) queryParams.append('payment_source', params.payment_source);
    if (params.payment_status) queryParams.append('payment_status', params.payment_status);
    if (params.from) queryParams.append('from', params.from);
    if (params.to) queryParams.append('to', params.to);
    
    const url = `${BASE_URL}${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
    const response = await apiService.get(url);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message || 'Failed to list transactions');
  }
};

export const getTransaction = async (transactionId) => {
  try {
    const response = await apiService.get(`${BASE_URL}/${transactionId}`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message || 'Failed to fetch transaction');
  }
};

export const updateTransaction = async (transactionId, updateData) => {
  try {
    const response = await apiService.put(`${BASE_URL}/${transactionId}`, updateData);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message || 'Failed to update transaction');
  }
};

export const deleteTransaction = async (transactionId) => {
  try {
    const response = await apiService.delete(`${BASE_URL}/${transactionId}`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message || 'Failed to delete transaction');
  }
};

export const cancelTransaction = async (transactionId) => {
  try {
    const response = await apiService.post(`${BASE_URL}/${transactionId}/cancel`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message || 'Failed to cancel transaction');
  }
};